import routeCodes from 'common/constants/route-codes';
import { dishesSteps } from 'common/constants/menu';

import * as types from './types';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const initialState = {
  listData: {
    id: 'dishes',
    title: 'I tuoi piatti/prodotti',
    description:
      'Crea o modifica i piatti/prodotti del tuo menù.  ',
    href: routeCodes.menuDishesEdit,
    createLink: routeCodes.menuDishesCreate,
    items: [],
  },
  itemLoading: true,
  currentItem: {},
  deleteInProcess: false,
  errors: null,
  listFetched: false,
  createOrUpdateInProcess: false,
  formStep: dishesSteps.first,
  completedSteps: [dishesSteps.first],
};

const dishesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DISHES_GET_SUCCESS:
      return {
        ...state,
        listFetched: true,
        listData: {
          ...state.listData,
          items: action.payload,
        },
      };
    case types.RESET_DISHES_LIST_DATA:
      return {
        ...state,
        listFetched: false,
        listData: {
          id: 'dishes',
          title: 'I tuoi piatti/prodotti',
          description:
            'Inserisci e modifica i piatti/prodotti del tuo menù.',
          href: routeCodes.menuDishesEdit,
          createLink: routeCodes.menuDishesCreate,
          items: [],
        }
      };
    case types.CHANGE_FORM_STEP:
      return {
        ...state,
        formStep: action.payload.step,
        completedSteps: action.payload.completedSteps,
      };
    case types.DISHES_CREATE_OR_UPDATE_REQUEST:
      return {
        ...state,
        createOrUpdateInProcess: true,
      };
    case types.RESET_DISHES_ERRORS:
      return {
        ...state,
        errors: null,
      };
    case types.DISHES_GET_BY_ID_REQUEST:
    case types.DISHES_GET_BY_ID_FAILURE:
      return {
        ...state,
        itemLoading: true,
      };
    case types.DISHES_GET_BY_ID_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        currentItem: action.payload,
      };
    case types.DISHES_CREATE_OR_UPDATE_FAILURE:
      return {
        ...state,
        errors: action.payload,
        createOrUpdateInProcess: false,
      };
    case types.DISHES_CREATE_OR_UPDATE_SUCCESS:
      return {
        ...state,
        createOrUpdateInProcess: false,
        formStep: dishesSteps.first,
        completedSteps: [dishesSteps.first],
      };
    case types.DISHES_DELETE_REQUEST:
      return {
        ...state,
        deleteInProcess: true,
      };
    case types.DISHES_DELETE_FAILURE:
    case types.DISHES_DELETE_SUCCESS:
      return {
        ...state,
        deleteInProcess: false,
      };
    case types.DISHES_CHANGE_POSITION_SUCCESS: {
      const { items } = state.listData;
      const { position, originalPosition } = action.payload;
      const newItems = reorder(items, originalPosition,position);
      
      return {
        ...state,
        listData: {
          ...state.listData,
          items: newItems,
        }
      };
    }
    default:
      return state;
  }
};

export default dishesReducer;
